import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Flame, Eye, TrendingUp } from "lucide-react";

export default function TopReadStrip() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/news-trending").then((r) => setItems(r.data.slice(0, 5))).catch(() => {});
  }, []);
  if (items.length === 0) return null;
  const top = items[0];

  return (
    <section className="mb-8 rounded-xl bg-gradient-to-br from-red-50 via-orange-50 to-amber-50 border-2 border-red-200 overflow-hidden" data-testid="top-read-strip">
      <div className="p-5 md:p-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-red-500 to-orange-600 text-white flex items-center justify-center shadow-md">
            <Flame className="w-5 h-5"/>
          </div>
          <div>
            <div className="uppercase tracking-[0.22em] text-[9px] text-red-700 font-black">Most Read · जनता की पसंद</div>
            <h3 className="font-devnagri-heading text-lg md:text-xl font-black text-[#0F172A] leading-tight">आज सबसे ज़्यादा पढ़ी जा रही ख़बरें</h3>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Link to={`/article/${top.slug}`} className="md:col-span-2 bg-white rounded-lg border border-red-200 overflow-hidden hover:shadow-md transition group flex flex-col md:flex-row" data-testid="tr-hero">
            {top.image_url && (
              <div className="md:w-48 shrink-0 aspect-video md:aspect-auto bg-slate-100 relative">
                <img src={top.image_url} alt={top.title} className="w-full h-full object-cover group-hover:scale-105 transition"/>
                <span className="absolute top-2 left-2 bg-red-600 text-white text-[9px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full shadow">#1</span>
                {top.is_hot && (
                  <span className="absolute top-2 right-2 bg-emerald-500 text-white text-[9px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full shadow inline-flex items-center gap-0.5">
                    <TrendingUp className="w-3 h-3"/> HOT
                  </span>
                )}
              </div>
            )}
            <div className="p-4 flex-1 min-w-0">
              <div className="tag-cat text-[10px] mb-2">{top.category}</div>
              <h4 className="font-devnagri-heading text-lg font-black text-[#0F172A] leading-tight line-clamp-3 group-hover:text-[#DC2626] transition">{top.title}</h4>
              <div className="mt-2 inline-flex items-center gap-2">
                <span className="inline-flex items-center gap-1 text-xs text-red-700 font-bold">
                  <Eye className="w-3.5 h-3.5"/> {(top.views || 0).toLocaleString("hi-IN")} व्यू
                </span>
                {top.is_hot && (
                  <span className="inline-flex items-center gap-0.5 text-[10px] text-emerald-700 font-black">
                    <TrendingUp className="w-3 h-3"/> तेज़ बढ़ रही है
                  </span>
                )}
              </div>
            </div>
          </Link>
          <div className="grid grid-cols-1 gap-2">
            {items.slice(1, 5).map((n, i) => (
              <Link key={n.id} to={`/article/${n.slug}`} className="bg-white rounded-md border border-amber-100 p-2.5 hover:shadow-sm transition flex items-center gap-2" data-testid={`tr-item-${i}`}>
                <span className="w-6 h-6 shrink-0 rounded-full bg-red-100 text-red-700 flex items-center justify-center font-black text-xs">#{i + 2}</span>
                <div className="min-w-0 flex-1">
                  <div className="font-bold text-xs text-[#0F172A] truncate flex items-center gap-1">
                    {n.title}
                    {n.is_hot && <TrendingUp className="w-3 h-3 text-emerald-600 shrink-0" title="तेज़ बढ़ रही"/>}
                  </div>
                  <div className="text-[10px] text-slate-500">{n.category}</div>
                </div>
                <div className="inline-flex items-center gap-0.5 shrink-0 bg-red-50 text-red-700 text-[10px] font-black px-1.5 py-0.5 rounded-full">
                  <Eye className="w-3 h-3"/> {n.views || 0}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
